import {withTranslation, WithTranslation} from 'react-i18next';
import {withStyles, WithStyles} from '@material-ui/core/styles';

import {technologiesStyles} from 'src/Components/Technologies/technologiesStyles';
import DockerIcon from 'src/Components/Icons/DockerIcon';
import TechCircle from 'src/Components/Technologies/TechCircle';

const Docker = (props: INextJsProps) => (
	<TechCircle
		className={props.classes.docker}
		icon={<DockerIcon />}
		label={props.t('docker')}
	/>
)

interface INextJsProps extends WithTranslation, WithStyles {}

export default withStyles(technologiesStyles)(withTranslation('technology')(Docker));
